import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content', 'button'];

  toggle() {
    const expanded = !this.contentTarget.hidden;

    this.contentTarget.hidden = expanded;
    this.buttonTarget.setAttribute('aria-expanded', !expanded);
    this.element.classList.toggle('is-open', !expanded);

    const contentHeight = this.element.querySelector(
      '[data-target="accordion.content"]',
    ).scrollHeight;
    this.element.querySelector(
      '[data-target="accordion.content"]',
    ).style.height = expanded ? '0' : `${contentHeight}px`;
  }
}
